<rt-scrollable class="dialog-scroll-container">
  @if (!shouldBeFullscreen()) {
    <div class="dialog-scroll-content">
      <div
        class="dialog-backdrop"
        (click)="
          !dialogConfig.disableClose && !dialogConfig.disableCloseOnBackdrop ? close() : null
        "
      ></div>
      @if (dialogConfig.backdropStyle === 'cover' && dialogCloseVisible) {
        <ng-template [ngTemplateOutlet]="dialogClose" />
      }
      <div
        class="dialog-container"
        cdkTrapFocus
        [class.vertically-centered]="dialogConfig?.containerOptions?.verticallyCentered"
      >
        <div
          [style.width]="dialogConfig.width"
          [style.maxWidth]="dialogConfig.maxWidth"
          [style.minWidth]="dialogConfig.minWidth"
          [style.height]="dialogConfig.height"
          class="dialog-content"
          [class.no-margin]="contentWithoutMargin"
        >
          <ng-template cdkPortalOutlet />
          @if (dialogConfig.backdropStyle === 'default' && dialogCloseVisible) {
            <ng-template [ngTemplateOutlet]="dialogClose" />
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="dialog-scroll-content">
      <div
        class="dialog-backdrop"
        (click)="
          !dialogConfig.disableClose && !dialogConfig.disableCloseOnBackdrop ? close() : null
        "
      ></div>
      <div
        class="dialog-container"
        cdkTrapFocus
        [class.vertically-centered]="dialogConfig?.containerOptions?.verticallyCentered"
      >
        <div class="dialog-content">
          <ng-container [ngTemplateOutlet]="dialogClose" />
          <ng-template cdkPortalOutlet />
        </div>
      </div>
    </div>
  }
</rt-scrollable>

<ng-template #dialogClose>
  <div class="dialog-close dialog-backdrop-style-{{ dialogConfig.backdropStyle }}">
    <rt-dialog-close [closeTooltip]="dialogConfig.closeTooltip" (click)="close()" />
  </div>
</ng-template>
